module.exports = __webpack_public_path__ + "img/image.45c3ab02.png";